import { useMatch } from '@tanstack/react-router';
import { createContext, type ReactNode, useContext } from 'react';

const RouteLoaderDataContext = createContext<unknown>(undefined);

/** Hands the current route match's loader data to the page below; read with `useRouteLoaderData`. */
export function RouteLoaderDataProvider({ children }: { children: ReactNode }) {
  const loaderData: unknown = useMatch({
    strict: false,
    shouldThrow: false,
    // Query refs carry symbol keys that a structural copy would drop.
    structuralSharing: false,
    select: (match) => match.loaderData,
  });
  return <RouteLoaderDataContext.Provider value={loaderData}>{children}</RouteLoaderDataContext.Provider>;
}

/** The current route's loader data, or undefined outside a routed page (cold mounts, router-less tests). */
export function useRouteLoaderData(): unknown {
  return useContext(RouteLoaderDataContext);
}
